import React from "react";

import Job from "../../../../../sdk/containers/Job";
import { PREPARING, REGISTERING } from "../../../slice";
import load_img from '../img/gif-load.gif';
import styles from './WaitWidget.module.css';

const WaitWidget = ({ job, status, fileType }) => {
  if (status === PREPARING) { return null; }

  let msg = '';
  if (status === REGISTERING || job === null || job.status === Job.REGISTERED) {
    msg = '処理を開始中です...';
  } else if (job.status === Job.GENERATING_WORD) {
    msg = fileType + 'ファイルを生成中です...'
  } else if (job.status === Job.GENERATING_IMAGE) {
    msg = fileType + 'ファイルに貼り付ける画像を生成中です (' + job.finished_images.toString() + ' / ' + job.total_images.toString() + ')';
  }

  return (
    <div className={styles.wait}>
      <div className={styles.message}>
        <h1>お待ち下さい</h1>

        <div>
          <p>{msg}</p>
          <p><img src={load_img} alt="loading" /></p>
        </div>
      </div>
    </div>
  )
}

export default WaitWidget;
